export const HEIGHT = 600
export const COLUMN_HEADER_HEIGHT = 120
export const ROW_HEADER_HEIGHT = 120
